const CancelPlan = {
  mounted() {
    this.handleClick = (e) => {
      const lineBreak = "%0D%0A";
      const emailAddress = "support@collava.app";
      const subject = "Subscription Cancellation Request";
      const body = `Please cancel my subscription of the plan: ${lineBreak} The e-mail used during the subscription was: ${lineBreak} I have some feedback about Collava: ${lineBreak}`;
      const mailtoLink = `mailto:${emailAddress}?subject=${subject}&body=${body}`;
      this.el.href = mailtoLink;
    };
    this.el.addEventListener("click", this.handleClick);
  },
  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
  },
};

export default CancelPlan;
